import script from "./canva_cta_variant_b.vue?vue&type=script&setup=true&lang=js"
export * from "./canva_cta_variant_b.vue?vue&type=script&setup=true&lang=js"

import "./canva_cta_variant_b.vue?vue&type=style&index=0&id=61237d0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61237d0c"]])

export default __exports__